import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.search";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { parse as parseQueryString } from 'querystring';
import cookie from 'cookie';
import { SCREEN_TYPES } from 'constants/media-queries';
var UPDATE_REQUEST = 'classpass/request/UPDATE_REQUEST';
export var setRequestDetailsOnServer = function setRequestDetailsOnServer(req) {
  return {
    type: UPDATE_REQUEST,
    req: req
  };
};
export var setRequestDetailsOnClient = function setRequestDetailsOnClient() {
  return {
    type: UPDATE_REQUEST
  };
};
export var selectQuery = function selectQuery(state) {
  return state.request.query;
};
export var selectDeviceType = function selectDeviceType(state) {
  return state.request.deviceType;
};
export var getInitialState = function getInitialState() {
  return {
    protocol: '',
    query: {},
    path: '',
    hostname: '',
    cookies: {},
    userAgent: ''
  };
};
export default function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getInitialState();
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case UPDATE_REQUEST:
      {
        if (__SERVER__) {
          var MobileDetect = require('mobile-detect');

          var req = action.req;

          if (req) {
            var device = new MobileDetect(req.get('user-agent'));
            var deviceType;

            if (device.phone()) {
              deviceType = SCREEN_TYPES.phone;
            } else if (device.tablet()) {
              deviceType = SCREEN_TYPES.tablet;
            } else if (!device.mobile()) {
              deviceType = SCREEN_TYPES.desktop;
            } else {
              deviceType = SCREEN_TYPES.unknown;
            }

            var _cookies = _objectSpread({}, cookie.parse(req.get('cookie') || ''), req.cookies);

            return {
              protocol: req.protocol,
              query: req.query,
              path: req.path,
              hostname: req.hostname,
              cookies: _cookies,
              visitorId: _cookies.cpVisitorId,
              deviceType: deviceType,
              userAgent: req.get('user-agent'),
              baseUrl: "".concat(req.protocol, "://").concat(req.hostname, "/"),
              currentFullUrl: "".concat(req.protocol, "://").concat(req.hostname).concat(req.originalUrl)
            };
          }
        }

        var cookies = cookie.parse(document.cookie || '');
        return _objectSpread({}, state, {
          protocol: window.location.protocol.replace(/:$/, ''),
          query: window.location.search ? parseQueryString(window.location.search.substr(1)) : {},
          path: window.location.pathname,
          hostname: window.location.host.replace(/:\d+$/, ''),
          cookies: cookies,
          userAgent: navigator.userAgent,
          baseUrl: "".concat(window.location.protocol, "//").concat(window.location.host.replace(/:\d+$/, ''), "/"),
          currentFullUrl: window.location.href,
          visitorId: cookies.cpVisitorId
        });
      }

    default:
      return state;
  }
}